// extracted by mini-css-extract-plugin
export default {"gray":"Overview_gray__DRoXd","content":"Overview_content__9IzFO","bottomRow":"Overview_bottomRow__pXYNG"};